import axios from 'axios';
import { getAuth } from 'firebase/auth';

const instance = axios.create({
  baseURL: 'https://vm.loungeatlas.com' //'https://172.203.251.155/',//'http://172.203.251.155:8000', // Update if your backend URL is different
  // baseURL: 'http://127.0.0.1:8000',
});

// const instance = axios.create({
//   baseURL: "https://wa-ieg-loungeatlas-portal-dev-caeast-grayhhf6ggcggaa8.canadaeast-01.azurewebsites.net/",
// });


instance.interceptors.request.use(async (config) => {
  const auth = getAuth();
  const user = auth.currentUser;
  if (user) {
    const token = await user.getIdToken();
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default instance;
